import React, { ReactNode } from 'react'
import MainContainer from '../MainContainer'
import styles from './page-wrapper.module.scss'
import cx from 'classnames'
import { ClassNameProps } from 'types/utilities'

interface Props extends ClassNameProps {
  children: ReactNode
}

const PageWrapper = ({ children, className }: Props) => {
  return <MainContainer className={cx(styles.wrapper, className)}>{children}</MainContainer>
}

export default PageWrapper
